import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

const AppModal = ({
  show,
  onHide,
  title,
  body,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  confirmDisabled,
  loading,
  centered = true,
  footer,
  children,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered={centered}>
      {title && (
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>{body || children}</Modal.Body>
      {(footer || onConfirm || onCancel) && (
        <Modal.Footer>
          {footer ? (
            footer
          ) : (
            <>
              {onCancel && (
                <Button variant='secondary' onClick={onCancel}>
                  {cancelText}
                </Button>
              )}
              {onConfirm && (
                <Button
                  variant='primary'
                  onClick={onConfirm}
                  disabled={confirmDisabled}>
                  {confirmText}
                  {loading && (
                    <Spinner
                      style={{
                        width: 20,
                        height: 20,
                        marginLeft: 10,
                        color: 'white',
                      }}
                      animation='border'
                      role='status'
                    />
                  )}
                </Button>
              )}
            </>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default AppModal;
